import { PAGE_TYPES } from '../shared/utils/analytics/constants'

export const microPrefix = 'nol-portal-consulting'

export function getPageType(slug) {
	if (slug === '/entre-nosotras/consultorios/') return PAGE_TYPES.GENERIC

	return PAGE_TYPES.GENERIC
}
